import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";
import CustomTooltip from "@Components/CustomTooltip";
import IconButton from "@material-ui/core/IconButton";
import Language from "sccLanguage";
import Legal from "../Legal/Legal";
import Logo from "../../../legal/data/NortacVectorLogo.png"
import "../../styles/LegalPage.scss";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const translateLegal = (text) => {
// MainPage tranlation = "t24.html"
  if (window.location.href.indexOf("t24.html") > -1) {
    return Language.translate(text);
// Login translation = "index.html"
  } else {
    let queryParameters = window.location.search;
    let languageCode =
      !queryParameters || queryParameters === ""
        ? "en"
        : queryParameters.split("=")[1];
    return Language.translateLogin(text, languageCode);
  }
}


export default function LegalPage (props) {

  const showCancel = props.onCancelAction ? true : false;


  const handleOKClick = () => {
    props.onOkAction();
  };

  const handleCancelClick = () => {
    if(showCancel) {
      props.onCancelAction();
    }
  };


  return (

    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
      className="LegalPage"
    > 

      <div className="main-header">
        <div className="about">
          {translateLegal("ABOUT")}
        </div>
        <div className="titan-version">
          TITAN by NORTAC - version 3.5.0
        </div>
        <div className="license-copyright">
          {translateLegal("License and Copyright Notices")}
        </div>
      </div>
      
      <Divider/>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <span style={{ top: 0, right: 0, position: "absolute" }}>
            <CustomTooltip
              title={translateLegal("Close Menu")}
              placement="bottom"
            >
              <IconButton
                onClick={showCancel ? handleCancelClick : handleOKClick}
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </CustomTooltip>
          </span>
          <span style={{ color: "black", fontSize: "1rem" }}>{props.text}</span>
          {props.children}
        </DialogContentText>
      </DialogContent>
      
      <Legal translateLegal={translateLegal} />

      <DialogActions>
        {showCancel && (
          <Button
            onClick={handleCancelClick}
            variant="contained"
            color="default"
            startIcon={<CloseIcon />}
          >
          </Button>
        )}
      </DialogActions>
      
      <Divider/>
      
      <div className="footer">
        <div className="footer-header">
          <img className="footer-logo" src={Logo}></img>{translateLegal("Privacy Policy")} | Nortac Defence
        </div>

        <div className="footer-body">
          <p>{translateLegal("For any questions contact")}</p>
          <p>nortac@nortacdefence.com</p>
          <p>{translateLegal("Copyright")} (C) 2023 Nortac Defence</p>
          <p>{translateLegal("All Rights Reserved")}</p>
        </div>
      </div>

    </Dialog>
  );
}